import { d as distExports } from '../_virtual/index.js';

class EventEmitter {
  constructor(globalOption) {
    this._eventEmitter = new distExports.EventEmitter(globalOption);
  }
  _eventEmitter;
  on(event, listener, option) {
    this._eventEmitter.on(event, listener, option);
  }
  once(event, listener, option) {
    this._eventEmitter.on(event, listener, option);
  }
  off(event, listener) {
    this._eventEmitter.off(event, listener);
  }
  emit(event, ...args) {
    this._eventEmitter.emit(event, ...args);
  }
}

export { EventEmitter };
//# sourceMappingURL=event-emitter.js.map
